import React from 'react';
import ReactDOM from 'react-dom/client';
import axios from 'axios';
import './index.css';

import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { AppConfigProvider } from './AppConfigProvider';

axios.defaults.withCredentials = true;

// Intercept cross-origin requests to manually attach the CSRF token
axios.interceptors.request.use((config) => {
  const xsrfCookie = document.cookie
    .split('; ')
    .find(row => row.startsWith('XSRF-TOKEN='));

  if (xsrfCookie) {
    const token = xsrfCookie.split('=')[1];
    config.headers['X-XSRF-TOKEN'] = decodeURIComponent(token);
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AppConfigProvider>
        <App />
      </AppConfigProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
